import React from 'react'
import SuccessIndicator from 'react-success-indicator'

export default () => {
  return <SuccessIndicator size='48px' color='rgba(67, 160, 71, 0.7)'/>
}
